import { NSMenuActionProps } from "namirasoft-site-react";
export class BillWatchMenus
{
    static BookCall(): NSMenuActionProps
    {
        return {
            id: "1",
            menu_item: "Book a free call",
            isActive: () =>
            {
                return true;
            },
            onClick: {
                action: () =>
                {
                    let link = "https://koalendar.com/e/namira-software-corporation";
                    window.open(link, "_open");
                },
                showLoading: false
            }
        };
    }
    static Run(getIDs: () => string[], run: (id: string) => void): NSMenuActionProps
    {
        return {
            id: "1",
            menu_item: "Run",
            isActive: () => getIDs().length === 1,
            onClick: {
                showLoading: false,
                action: () => run(getIDs()[0]),
            }
        };
    }
}